<template lang="pug">
  .products(:name="routeName")
    v-layout(v-if="!watch" v-rc-loader="!ready && !watch" style="height: 200px;")
    rc-table.pb-5(
      v-if="watch"
      :items="products"
      :headers="headers"
      :loading="!ready"
      :deleteAction="false"
      :totalItems="total"
      :clickToVisit="false"
      @recall="getProducts"
    )
      template(slot="resultCount")
        v-layout.justify-end.title.pr-3 {{ formatNum(total) }} résultat{{ total > 1 ? 's' : '' }} ({{ formatNum(coreCount) }} produit{{ coreCount > 1 ? 's' : '' }} core, {{ formatNum(optionCount) }} option{{ optionCount > 1 ? 's' : '' }})
    v-layout.justify-end.total-price.grey.subheading.py-2.px-4(v-if="ready")
      div.price-wrapper TOTAL : {{ formatCurr(totalPrice) }} H.T./mois
</template>

<script>
import axios from 'axios';
import RcTable from '@/components/RcTable/RcTable.vue';

export default {
  components: {
    RcTable,
  },
  data() {
    return {
      products: [],
      ready: false,
      total: 0,
      totalPrice: 0,
      watch: true,
      coreCount: 0,
      optionCount: 0,
      headers: [
        {
          label: 'Destination',
          // sortable: true,
          column: 'destination_name',
          type: 'list',
          filters: {
            type: 'text',
            operands: ['ilike'],
            field: 'd.name',
          },
          width: '19%',
        },
        {
          label: '',
          type: 'tile',
          column: 'image_url',
          padding: 'none',
          width: '76px',
          defaultIcon: 'store',
        },
        {
          label: 'Compte',
          // sortable: true,
          column: 'client_name',
          type: 'route',
          filters: {
            type: 'text',
            operands: ['ilike'],
            field: 'u.display_name',
          },
          width: '18%',
          to: {
            name: 'client_contacts',
            params: {
              clientId: 'client_id',
            },
          },
        },
        ...(this.$store.state.app.user.touristicProvider || this.$store.state.app.destination.id == 1 ? 
        [
          {
            label: 'Type',
            // sortable: true,
            column: 'client_types',
            type: 'list',
            filters: {
              type: 'autocomplete',
              operands: ['in'],
              field: 'pt.name',
            },
            width: '15%',
          },
        ] : []),
        {
          label: 'Code postal',
          // sortable: true,
          column: 'zip',
          filters: {
            type: 'text',
            operands: ['startsWith'],
            field: 'u.zip',
          },
          width: '180px',
        },
        {
          label: 'Ville',
          // sortable: true,
          column: 'city',
          filters: {
            type: 'text',
            operands: ['ilike'],
            field: 'u.city',
          },
          width: '15%',
        },
        {
          label: 'Service',
          // sortable: true,
          column: 'service_name',
          type: 'product_instance',
          filters: {
            type: 'autocomplete',
            operands: ['in'],
            field: 'ct.id',
          },
          width: '20%',
        },
        {
          label: 'Tarif',
          // sortable: true,
          column: 'price',
          width: '13%',
        },
      ],
    };
  },
  created(){
    this.getProducts();
    if (this.$store.state.app.destination.touristicProvider || this.$store.state.app.destination.id == 1) {
      this.getTypes();
      this.getServices();
    }
  },
  watch: {
    $route(newValue) {
      if (newValue.name === 'product_detail') {
        this.watch = false;
        this.getProducts();
        this.getTypes();
        this.getServices();
      }
    },
  },
  computed: {
    routeName() {
      const name = this.$store.state.app.productCategories.find(x => x.id == this.$route.params.productId)?.name;
      if (name) {
        this.$store.dispatch('routes/setBreadcrumbs', { breadcrumbs: [{text: name}] });
      }
      return name;
    },
  },
  methods: {
    formatNum(n) {
      return new Intl.NumberFormat('fr-FR').format(n);
    },
    formatCurr(price) {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(price)
    },
    async getTypes() {
      const response = await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).get(`v2/erp/account/${this.$store.state.app.user.parent_id}/categories/${this.$route.params.productId}/products/types`);
      const products = response.data.values
        .map(bord => { return { name: this.$store.state.app.sheetCategories[bord.name.toLowerCase()] || bord.name || null, id: bord.name} })
        .filter(x => !!x.name);
      const newHeaders = JSON.parse(JSON.stringify(this.headers))
      const pFilter = newHeaders.find(x => x.column === 'client_types');
      pFilter.filters.values = products;
      this.headers = newHeaders;
    },
    async getServices() {
      const response = await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).get(`/v2/erp/account/${this.$store.state.app.user.parent_id}/categories/${this.$route.params.productId}/products/services`);
      const products = response.data.values;
      const newHeaders = JSON.parse(JSON.stringify(this.headers))
      const pFilter = newHeaders.find(x => x.column === 'service_name');
      pFilter.filters.values = products;
      this.headers = newHeaders;
    },
    getProducts(params = { start: 0, size: 100 }) {
      this.ready = false;
      axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).post(`/v2/erp/account/${this.$store.state.app.user.parent_id}/categories/${this.$route.params.productId}/products`, params).then(response => {
        this.products = response.data.values.map(it => {
            it.client_types = it.client_types
              .filter(x => !!x)
              .map(bord => this.$store.state.app.sheetCategories[bord.toLowerCase()] || bord)
              .filter(x => !!x)
            if (!it.destination_id) {
              it.destination_id = it.client_id;
              it.destination_name = it.client_name;
            }
            it.image_url = it.client_image_is_defined ? `/v2/erp/contacts/${it.client_id}/image` : null;
            return it;
          }).map(it => { it.price = it.price === 0 ? it.sale_ok ? 'Offert' : 'Gratuit' : `${this.formatCurr(it.price)} H.T./mois`; return it; })
        this.total = response.data.count;
        this.coreCount = response.data.count_parent;
        this.optionCount = response.data.count_children;
        this.totalPrice = response.data.price;
        this.watch = true;
        this.ready = true;
      }).catch(e => {
        this.$store.dispatch('errorHandler/throwError', { title: 'Il y a eu une erreur dans la récupération des produits.' })
        this.watch = true;
        this.ready = true;
      });
    },
  },
};
</script>

<style lang="scss">
  .total-price {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 2;
  }
</style>
